import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const hintVariants = cva("h-hint", {
  variants: {
    variant: {
      default: "",
      error: "h-hint--error",
    },
  },
  defaultVariants: {
    variant: "default",
  },
})

export interface HintProps
  extends React.HTMLAttributes<HTMLParagraphElement>,
    VariantProps<typeof hintVariants> {}

const Hint = React.forwardRef<HTMLParagraphElement, HintProps>(
  ({ className, variant, ...props }, ref) => {
    return (
      <p
        ref={ref}
        className={cn(hintVariants({ variant }), className)}
        {...props}
      />
    )
  },
)
Hint.displayName = "Hint"

export { Hint, hintVariants }
